<template>
	<Head title="Coleta de Foto"></Head>

	<div class="container exam-capture-page">
		<div class="row align-items-center mt-10 mb-10 row-logo exam-logo-row">
			<div class="col mx-auto text-center">
				<img
					alt="Logo Habilite-se"
					src="/habil/images/logo.svg"
					class="h-35px" />
			</div>
		</div>

		<div class="row align-items-center row-card">
			<div class="col-sm-10 col-md-9 mx-auto text-center">
				<div class="card">
					<div class="card-body exam-card-body">
						<toastInfo
							:test_over="test_over"
							:test_middle="test_middle"
							:userName="props.user.name"
							:userCPF="props.user.cpf"
							:CFCName="props.subtenant_name"
							:computerName="props.descricao_computer" />
						<div class="text-center exam-heading">
							<h2 class="m-0">Coleta de Biometria e Foto</h2>
							<p
								class="fw-bolder fs-5 text-gray-600 exam-heading-caption">
								Leia com atenção as instruções de cada etapa
							</p>
						</div>
						<div class="row justify-content-center">
							<div class="col-md-12">
								<ul id="progressbar" class="exam-progressbar-two">
									<li class="active fs-5" id="biometria">
										<strong>Biometria</strong>
									</li>
									<li id="foto" class="active fs-5">
										<strong>Coleta de Foto</strong>
									</li>
								</ul>
							</div>
						</div>
						<div v-if="photo_error" class="error">
							<div
								class="alert alert-danger alert-dismissible d-flex flex-column flex-sm-row p-5 mb-10">
								<div class="d-flex flex-column">
									<span>{{ error_message }}</span>
								</div>
							</div>
						</div>
						<div class="exam-capture-layout">
							<section
								class="exam-instructions"
								aria-labelledby="photo-instructions-title">
								<p class="exam-step-label">Etapa atual</p>
								<h2
									id="photo-instructions-title"
									class="exam-instructions-title">
									Capture sua foto
								</h2>
								<p class="exam-instructions-lead">
									Olhe para a câmera e clique no botão azul. A
									foto não será capturada sozinha.
								</p>

								<div class="exam-checklist" role="list">
									<div
										class="exam-checklist-item"
										role="listitem">
										<span class="exam-checklist-number"
											>1</span
										>
										<span
											>Retire boné, óculos escuros ou
											qualquer acessório que cubra o
											rosto.</span
										>
									</div>
									<div
										class="exam-checklist-item"
										role="listitem">
										<span class="exam-checklist-number"
											>2</span
										>
										<span
											>Mantenha a cabeça reta e olhe para
											a câmera.</span
										>
									</div>
									<div
										class="exam-checklist-item"
										role="listitem">
										<span class="exam-checklist-number"
											>3</span
										>
										<span
											>Clique em
											<strong>Capturar foto</strong> e
											aguarde a contagem.</span
										>
									</div>
								</div>
							</section>

							<section
								class="exam-capture-panel"
								aria-live="polite">
								<div id="box-photo" class="exam-media-box">
									<div
										v-if="photoStep === 'countdown'"
										class="exam-media-overlay exam-countdown-overlay"
										style="z-index: 1">
										<strong>
											{{ waiting_photo_seconds }}
										</strong>
									</div>

									<img
										v-show="photo_completed"
										id="photo-preview"
										:src="`data:image/jpeg;base64,${b64_photo}`"
										class="rounded exam-photo-preview"
										alt="Foto capturada para validação" />

									<img
										v-if="
											env_local &&
											b64_photo &&
											!photo_completed &&
											!props.browser_webcam_streaming_enabled
										"
										:src="`data:image/jpeg;base64,${b64_photo}`"
										class="exam-photo-preview"
										alt="Imagem de teste da câmera" />

									<div
										class="mask exam-camera-preview"
										v-if="
											!photo_completed &&
											props.browser_webcam_streaming_enabled
										">
										<browser_webcam_preview
											:width="300"
											:height="300" />
									</div>

									<div
										class="mask exam-camera-preview"
										v-show="
											!photo_completed &&
											!env_local &&
											!props.browser_webcam_streaming_enabled
										">
										<webrtc_video_player
											:auto="false"
											@started="camera_ready = true"
											:width="300"
											:height="300"
											class="exam-camera-player"
											style="height: 100%; width: 100%"
											ref="video_player_component"
											:source_url="
												props.webcam_webrtc_streaming_source
											"
											:streaming_auth_credential="
												props.streaming_auth_credential
											" />
									</div>
								</div>

								<button
									v-if="photoStep === 'idle'"
									@click="capturePhoto"
									id="btn-capture-photo"
									class="btn btn-primary btn-color exam-primary-action w-100">
									<span
										class="fa fa-lg fa-camera"
										aria-hidden="true"></span>
									Capturar foto
								</button>

								<button
									v-else-if="photoStep === 'camera_not_ready'"
									id="btn-capture-photo"
									class="btn btn-primary btn-color exam-primary-action w-100"
									disabled>
									<span
										class="fa fa-lg fa-spin fa-sync"
										aria-hidden="true"></span>
									Preparando câmera
								</button>

								<button
									v-else-if="photoStep === 'error'"
									@click="capturePhoto"
									id="btn-capture-photo"
									class="btn btn-primary btn-color exam-primary-action w-100">
									<span
										class="fa fa-lg fa-refresh"
										aria-hidden="true"></span>
									Tentar novamente
								</button>

								<div
									v-else-if="photoStep === 'success'"
									class="exam-success-actions">
									<button
										id="submit-photo"
										class="btn btn-primary btn-color exam-primary-action w-100"
										type="submit"
										:disabled="buttonLoading"
										@click="sendPhoto">
										<span
											v-if="buttonLoading"
											class="fa fa-lg fa-spin fa-sync"
											aria-hidden="true"></span>
										{{
											buttonLoading
												? 'Aguarde um momento...'
												: 'Avançar'
										}}
									</button>
									<button
										v-if="!buttonLoading"
										id="btn-tryagain-photo"
										class="btn btn-light-danger exam-secondary-action w-100"
										type="button"
										@click="resetProcess">
										<span
											class="fa fa-lg fa-refresh"
											aria-hidden="true"></span>
										Refazer foto
									</button>
								</div>
							</section>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
	import { Head, router, usePage } from '@inertiajs/vue3';
	import { ref, Ref, onMounted, computed } from 'vue';
	import axios from 'axios';
	import Swal from 'sweetalert2';
	import { commonStore } from '../../stores/common';
	import toastInfo from '../../components/Exam/toast_info.vue';
	import { checkConnection } from '../../websockets/WebsocketVerification';
	import webrtc_video_player from '../../components/Widgets/webrtc_video_player.vue';
	import browser_webcam_preview from '../../components/Exam/browser_webcam_preview.vue';
	import { browserWebcamStreamingStore } from '../../stores/browserWebcamStreaming';

	const common = commonStore();
	const props = defineProps({
		user: { type: Object, required: true },
		csrf_token: { type: String, required: true },
		next_step_route: { type: String, required: true },
		webcam_ws_url: { type: String, required: false, default: '' },
		action_store_photo: { type: String, required: true },
		startProcessValidateProdesp: { type: String, required: true },
		mock_biometry: { type: Boolean, required: false, default: false },
		allow_finger_change: { type: Boolean, required: false, default: false },
		finger_number: { type: Number, required: false, default: null },
		routeLogExam: { type: String, required: true },
		enrollmentTestId: { type: Number, required: true },
		final_exam_id: { type: String, required: true },
		get_biometry_capture_route: { type: String, required: true },
		logout_redirect_route: { type: String, required: true },
		enrollment_test: { type: Object, required: true },
		ws_client_id: { type: String, required: false, default: '' },
		maximum_retries: { type: Number, required: true },
		img_mocked: { type: String, required: true },
		test_middle: { type: Boolean, required: true },
		test_over: { type: Boolean, required: true },
		computer_uid: { type: String, required: true },
		descricao_computer: { type: String, required: true },
		subtenant_name: { type: String, required: true },
		is_ws_verification: { type: Boolean, required: true },
		logout_url: { type: String, required: true },
		is_agent_support_ws_verification: { type: Boolean, required: true },
		webcam_webrtc_streaming_source: { type: String, required: true },
		streaming_auth_credential: { type: String, required: true },
		spa_enabled: { type: Boolean, required: false, default: false },
		browser_webcam_streaming_enabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		open_camera_route: { type: String, required: false, default: '' },
	});

	const browserWebcam = browserWebcamStreamingStore();
	const btn_capture_photo: Ref<boolean> = ref(false);
	const buttonLoading: Ref<boolean> = ref(false);
	const waiting_photo_seconds: Ref<number> = ref(1);
	const photo_completed: Ref<boolean> = ref(false);
	const b64_photo: Ref<string> = ref('');
	const photo_error: Ref<boolean> = ref(false);
	const error_message: Ref<string> = ref('');
	const env_local = computed(() => usePage().props?.env === 'local');
	const video_player_component = ref<InstanceType<
		typeof webrtc_video_player
	> | null>(null);
	const camera_ready = ref(false);
	const connectionSpinner = ref(true);
	const connectionStatus = ref({
		connection: false,
		verified: false,
	});
	const iconError = `<div style="margin-left:43%; width:50px; height: 50px; border-radius: 80%; background-color: #f56c6c;">
		<i class="mt-5 fa-solid fa-xmark fa-lg" style="color: #ecf5ff;"></i>
	</div>`;

	const canCapturePhoto = computed(() => {
		if (props.browser_webcam_streaming_enabled) {
			return browserWebcam.isPublishing || browserWebcam.isMock;
		}

		return camera_ready.value || env_local.value;
	});

	const test_open = computed(() => {
		return !props.test_middle && !props.test_over;
	});

	const test_final = computed(() => {
		return props.test_over;
	});

	type PhotoStep =
		| 'camera_not_ready'
		| 'idle'
		| 'countdown'
		| 'success'
		| 'error';

	const photoStep = computed<PhotoStep>(() => {
		if (photo_completed.value) {
			return 'success';
		}

		if (photo_error.value) {
			return 'error';
		}

		if (btn_capture_photo.value) {
			return 'countdown';
		}

		if (!canCapturePhoto.value) {
			return 'camera_not_ready';
		}

		return 'idle';
	});

	onMounted(() => {
		if (
			props.browser_webcam_streaming_enabled &&
			!browserWebcam.isPublishing &&
			!browserWebcam.isMock
		) {
			router.visit(props.open_camera_route);
			return;
		}

		if (!props.browser_webcam_streaming_enabled) {
			resetCanvas();
		}

		if (env_local.value && !props.browser_webcam_streaming_enabled) {
			b64_photo.value = props.img_mocked;
		} else if (!props.browser_webcam_streaming_enabled) {
			video_player_component.value?.start();
		}
		common.startKeyUp();
		checkConnection(props, connectionStatus, connectionSpinner);

		setInterval(() => {
			checkConnection(props, connectionStatus, connectionSpinner);
		}, 25000);
	});

	async function resetCanvas() {
		const canvas_id = 'webcam-final-test-photo';
		const webcam_ws_url = props.webcam_ws_url;
		const canvas = document.getElementById(canvas_id);
		const settings = {
			canvas: canvas,
			pauseWhenHidden: false,
			audio: false,
			preserveDrawingBuffer: true,
		};
		if (env_local.value && canvas) {
			let ctx = (canvas as HTMLCanvasElement).getContext('2d');
			let bg = new Image();
			bg.src = props.img_mocked;
			bg.onload = function () {
				if (ctx) {
					ctx.drawImage(bg, 0, 0, 300, 145);
				}
			};
		} else {
			// @ts-ignore
			new window.JSMpeg.Player(webcam_ws_url, settings);
		}
	}

	function capturePhoto() {
		photo_error.value = false;
		error_message.value = '';
		btn_capture_photo.value = true;
		waitingSetInterval();
	}
	async function takePhoto() {
		if (props.browser_webcam_streaming_enabled) {
			return await browserWebcam.takePhoto();
		}

		return env_local.value
			? props.img_mocked
			: video_player_component.value?.takePhoto();
	}

	function waitingSetInterval() {
		timerWaitingPhotoSeconds();
		let timer: Ref<NodeJS.Timeout> = ref(
			setInterval(async () => {
				if (waiting_photo_seconds.value > 0) {
					waiting_photo_seconds.value =
						waiting_photo_seconds.value - 1;
				} else {
					const photo = await takePhoto();
					if (photo) {
						b64_photo.value = photo;
						photo_completed.value = true;
					} else {
						photo_error.value = true;
						error_message.value =
							'Não foi possível capturar a foto da webcam.';
					}
					clearInterval(timer.value);
				}
			}, 1000)
		);
	}

	function timerWaitingPhotoSeconds() {
		if (env_local.value) {
			waiting_photo_seconds.value = 1;
		} else {
			waiting_photo_seconds.value = 5;
		}
	}

	function resetProcess() {
		timerWaitingPhotoSeconds();
		btn_capture_photo.value = false;
		buttonLoading.value = false;
		photo_completed.value = false;
		photo_error.value = false;
		error_message.value = '';
		b64_photo.value = '';
	}

	function goto(url: string) {
        router.visit(url);
	}

	function validationErrorTitle() {
		if (test_open.value) {
			return 'Erro na abertura da Prova';
		}

		if (test_final.value) {
			return 'Erro no fechamento da Prova';
		}

		return 'Erro na verificação de Biometria';
	}

	function validationErrorLogDescription() {
		if (test_open.value) {
			return '[FALHA ABERTURA DE PROVA] - Houve uma falha ao tentar iniciar a prova';
		}

		if (test_final.value) {
			return '[FALHA FECHAMENTO DE PROVA] - Falha ao registrar resultado';
		}

		return '[FALHA VERIFICAÇÃO DE PROVA] - Houve uma falha ao verificar a biometria';
	}

	async function sendPhoto() {
		if (buttonLoading.value) {
			return;
		}

		buttonLoading.value = true;
		photo_error.value = false;
		error_message.value = '';

		try {
			await axios.post(props.action_store_photo, {
				responsePhoto: b64_photo.value,
			});
			await startVerify();
		} catch (error: any) {
			buttonLoading.value = false;
			photo_error.value = true;
			error_message.value =
				error.response?.data?.message ??
				error.message ??
				'Não foi possível salvar a foto.';
		}
	}

	async function startVerify() {
		try {
			const response = await axios.post(props.startProcessValidateProdesp, {
				enrollment_test_id: props.final_exam_id,
				...(props.allow_finger_change && props.mock_biometry && props.finger_number
					? { finger_number: props.finger_number }
					: {}),
			});

			goto(response.data.url);
		} catch (error: any) {
			const response = error.response?.data ?? {};
			const title = validationErrorTitle();
			const logDescription = validationErrorLogDescription();
			const message = response.message ?? 'Ocorreu um erro. Tente novamente!';

			buttonLoading.value = false;

			if (error.response?.status !== 422) {
				await axios
					.post(props.routeLogExam, {
						description: logDescription,
						enrollment_test_id: props.enrollmentTestId,
					})
					.catch(() => {});
			}

			Swal.fire({
				html: `
					${iconError}
					<div class="my-4 text-danger">
						<strong>${title}</strong>
					</div>
					Mensagem do Detran: ${message}
				`,
				confirmButtonText: 'Confirmar',
				confirmButtonColor: '#009EF7',
				allowOutsideClick: false,
			}).then(() => {
				if (response.should_logout) {
					goto(props.logout_redirect_route);
					return;
				}

				goto(props.get_biometry_capture_route);
			});
		}
	}
</script>

<style scoped>
.exam-capture-page {
	--exam-action-font-size: 18px;
	--exam-action-min-height: 56px;
	--exam-card-padding-block: 26px;
	--exam-checklist-font-size: 19px;
	--exam-checklist-gap: 14px;
	--exam-checklist-padding-block: 14px;
	--exam-checklist-padding-inline: 16px;
	--exam-checklist-number-size: 34px;
	--exam-countdown-size: 104px;
	--exam-gap: 24px;
	--exam-heading-caption-size: 15px;
	--exam-heading-margin-bottom: 20px;
	--exam-instructions-lead-size: 20px;
	--exam-instructions-title-size: 30px;
	--exam-layout-padding-inline: 26px;
	--exam-logo-margin: 4rem;
	--exam-media-size: 300px;
	--exam-page-title-size: 1.5rem;
	--exam-progressbar-icon-size: 50px;
	--exam-progressbar-icon-font-size: 18px;
	--exam-progressbar-line-top: 25px;
	--exam-progressbar-margin-bottom: 10px;
	--exam-progressbar-text-size: 12px;
}

.exam-logo-row {
	margin-bottom: var(--exam-logo-margin) !important;
	margin-top: var(--exam-logo-margin) !important;
}

.exam-card-body {
	padding: var(--exam-card-padding-block) 0;
}

.exam-heading {
	margin-bottom: var(--exam-heading-margin-bottom);
}

.exam-heading h2 {
	font-size: var(--exam-page-title-size);
}

.exam-heading-caption {
	color: #747a7e;
	font-size: var(--exam-heading-caption-size);
}

#progressbar {
	margin-bottom: var(--exam-progressbar-margin-bottom);
}

#progressbar li {
	font-size: var(--exam-progressbar-text-size);
}

#progressbar li:before {
	font-size: var(--exam-progressbar-icon-font-size);
	height: var(--exam-progressbar-icon-size);
	line-height: calc(var(--exam-progressbar-icon-size) - 5px);
	margin-bottom: 8px;
	width: var(--exam-progressbar-icon-size);
}

#progressbar li:after {
	top: var(--exam-progressbar-line-top);
}

.mask {
    mask-image: radial-gradient(
        ellipse 75% 95%,
        black 50%,
        rgba(0, 0, 0, 0.4) 51%
    );
    -webkit-mask-image: radial-gradient(
        ellipse 75% 95%,
        black 50%,
        rgba(0, 0, 0, 0) 51%
    );
    mask-border-width: 25%;
}

.exam-capture-layout {
    display: grid;
    grid-template-columns: minmax(0, 1.35fr) minmax(var(--exam-media-size), 0.65fr);
    gap: var(--exam-gap);
    padding: 0 var(--exam-layout-padding-inline);
    text-align: left;
}

.exam-instructions,
.exam-capture-panel {
    min-width: 0;
}

.exam-step-label {
    color: #022d62;
    font-size: var(--exam-step-label-size, 16px);
    font-weight: 700;
    margin-bottom: var(--exam-step-label-margin-bottom, 6px);
    text-transform: uppercase;
}

.exam-instructions-title {
    color: #181c32;
    font-size: var(--exam-instructions-title-size);
    font-weight: 800;
    line-height: 1.2;
    margin-bottom: var(--exam-title-margin-bottom, 10px);
}

.exam-instructions-lead {
    color: #3f4254;
    font-size: var(--exam-instructions-lead-size);
    font-weight: 700;
    line-height: var(--exam-instructions-line-height, 1.45);
    margin-bottom: var(--exam-lead-margin-bottom, 20px);
}

.exam-checklist {
    display: grid;
    gap: var(--exam-checklist-gap);
}

.exam-checklist-item {
    align-items: center;
    background: #f5f8fa;
    border: 1px solid #e4e6ef;
    border-radius: 8px;
    color: #3f4254;
    display: flex;
    font-size: var(--exam-checklist-font-size);
    font-weight: 700;
    gap: var(--exam-checklist-item-gap, 12px);
    line-height: var(--exam-checklist-line-height, 1.45);
    padding: var(--exam-checklist-padding-block) var(--exam-checklist-padding-inline);
}

.exam-checklist-item strong {
    color: #022d62;
}

.exam-checklist-number {
    align-items: center;
    background: #022d62;
    border-radius: 999px;
    color: #ffffff;
    display: inline-flex;
    flex: 0 0 var(--exam-checklist-number-size);
    font-size: var(--exam-checklist-number-font-size, 18px);
    height: var(--exam-checklist-number-size);
    justify-content: center;
    width: var(--exam-checklist-number-size);
}

.exam-capture-panel {
    text-align: center;
}

.exam-media-box {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-bottom: var(--exam-media-margin-bottom, 14px);
    min-height: var(--exam-media-size);
    position: relative;
}

.exam-media-overlay {
    align-items: center;
    background: rgba(255, 255, 255, 0.76);
    border-radius: 10px;
    display: flex;
    inset: 0;
    justify-content: center;
    position: absolute;
}

.exam-countdown-overlay {
    background: rgba(2, 45, 98, 0.72);
    color: #ffffff;
    flex-direction: column;
    font-weight: 800;
    gap: 8px;
    text-align: center;
}

.exam-countdown-overlay strong {
    align-items: center;
    background: #ffffff;
    border-radius: 999px;
    color: #022d62;
    display: inline-flex;
    font-size: var(--exam-countdown-font-size, 56px);
    height: var(--exam-countdown-size);
    justify-content: center;
    line-height: 1;
    width: var(--exam-countdown-size);
}

.exam-countdown-overlay span {
    font-size: var(--exam-countdown-label-size, 20px);
}

.exam-photo-preview,
.exam-camera-preview {
    border-radius: 8px;
    height: var(--exam-media-size);
    max-width: 100%;
    object-fit: cover;
    width: var(--exam-media-size);
}

.exam-camera-preview :deep(.browser-webcam-preview),
.exam-camera-preview :deep(.exam-camera-player),
.exam-camera-preview :deep(.exam-camera-player > div),
.exam-camera-preview :deep(video) {
    height: 100% !important;
    width: 100% !important;
}

.exam-camera-preview :deep(video) {
    object-fit: cover;
}

.exam-primary-action,
.exam-secondary-action {
    align-items: center;
    display: inline-flex;
    font-size: var(--exam-action-font-size);
    font-weight: 800;
    gap: 10px;
    justify-content: center;
    min-height: var(--exam-action-min-height);
    white-space: normal;
}

.exam-success-actions {
    display: grid;
    gap: var(--exam-success-actions-gap, 10px);
}

@media (max-height: 760px) {
	.exam-capture-page {
		--exam-action-font-size: 16px;
		--exam-action-min-height: 48px;
		--exam-card-padding-block: 16px;
		--exam-checklist-font-size: 16px;
		--exam-checklist-gap: 10px;
		--exam-checklist-padding-block: 10px;
		--exam-checklist-padding-inline: 12px;
		--exam-checklist-number-size: 30px;
		--exam-countdown-font-size: 48px;
		--exam-countdown-size: 88px;
		--exam-gap: 18px;
		--exam-heading-margin-bottom: 12px;
		--exam-instructions-lead-size: 17px;
		--exam-instructions-title-size: 25px;
		--exam-layout-padding-inline: 20px;
		--exam-logo-margin: 2rem;
		--exam-media-size: 260px;
		--exam-page-title-size: 1.35rem;
		--exam-progressbar-icon-size: 42px;
		--exam-progressbar-icon-font-size: 16px;
		--exam-progressbar-line-top: 21px;
		--exam-progressbar-margin-bottom: 6px;
		--exam-progressbar-text-size: 11px;
	}
}

@media (max-height: 680px) {
	.exam-capture-page {
		--exam-action-font-size: 15px;
		--exam-action-min-height: 44px;
		--exam-card-padding-block: 12px;
		--exam-checklist-font-size: 15px;
		--exam-checklist-gap: 8px;
		--exam-checklist-padding-block: 8px;
		--exam-checklist-padding-inline: 10px;
		--exam-checklist-number-size: 28px;
		--exam-countdown-font-size: 42px;
		--exam-countdown-size: 76px;
		--exam-gap: 14px;
		--exam-heading-caption-size: 14px;
		--exam-heading-margin-bottom: 8px;
		--exam-instructions-lead-size: 15px;
		--exam-instructions-title-size: 22px;
		--exam-lead-margin-bottom: 12px;
		--exam-logo-margin: 1rem;
		--exam-media-margin-bottom: 10px;
		--exam-media-size: 230px;
		--exam-page-title-size: 1.2rem;
		--exam-progressbar-icon-size: 36px;
		--exam-progressbar-icon-font-size: 14px;
		--exam-progressbar-line-top: 18px;
		--exam-progressbar-margin-bottom: 4px;
		--exam-progressbar-text-size: 10px;
		--exam-step-label-size: 14px;
	}
}

@media (max-height: 620px) {
	.exam-capture-page {
		--exam-action-font-size: 14px;
		--exam-action-min-height: 40px;
		--exam-card-padding-block: 8px;
		--exam-checklist-font-size: 13px;
		--exam-checklist-gap: 6px;
		--exam-checklist-item-gap: 8px;
		--exam-checklist-line-height: 1.25;
		--exam-checklist-number-font-size: 13px;
		--exam-checklist-number-size: 24px;
		--exam-checklist-padding-block: 6px;
		--exam-checklist-padding-inline: 8px;
		--exam-countdown-font-size: 34px;
		--exam-countdown-size: 62px;
		--exam-gap: 10px;
		--exam-heading-margin-bottom: 4px;
		--exam-instructions-lead-size: 13px;
		--exam-instructions-line-height: 1.3;
		--exam-instructions-title-size: 19px;
		--exam-layout-padding-inline: 14px;
		--exam-lead-margin-bottom: 8px;
		--exam-logo-margin: 0.5rem;
		--exam-media-margin-bottom: 8px;
		--exam-media-size: 190px;
		--exam-page-title-size: 1rem;
		--exam-progressbar-icon-font-size: 12px;
		--exam-progressbar-icon-size: 30px;
		--exam-progressbar-line-top: 15px;
		--exam-progressbar-margin-bottom: 2px;
		--exam-progressbar-text-size: 9px;
		--exam-step-label-margin-bottom: 2px;
		--exam-step-label-size: 12px;
		--exam-success-actions-gap: 6px;
		--exam-title-margin-bottom: 6px;
	}

	.exam-heading-caption {
		display: none;
	}
}
</style>
